import React from "react";
import dayjs from "dayjs";
import { getRentalStatus } from "../../getStatus";
import RequestDetailCTA from "../RequestDetailCTA";
import { RENTAL_STATUS } from "../../../Rentals/constant";
import { formatPhoneNumber } from "../../../../Utils/phoneNumberHelper";

export const rentalRequestColumns = [
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray whitespace-nowrap">
        Request ID
      </div>
    ),
    dataIndex: "id",
    sorter: (a, b) => a.id - b.id,
    render: (text) => (
      // will show the farmer name or the mobile number
      <div className="text-xs font-semibold font-aileron leading-4.5 text-black">
        {text}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray whitespace-nowrap">
        Requested By
      </div>
    ),
    dataIndex: "firstName",
    sorter: (a, b) => a?.firstName?.localeCompare(b?.firstName),
    render: (text, record) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray">
        {text ? `${record?.firstName} ${record?.lastName}` : "--"}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray whitespace-nowrap">
        Contact No.
      </div>
    ),
    dataIndex: "contactNo",
    sorter: (a, b) => a?.contactNo?.localeCompare(b?.contactNo),
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray">
        {formatPhoneNumber(text)}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray whitespace-nowrap">
        Hub Station
      </div>
    ),
    dataIndex: "hubName",
    sorter: (a, b) => a?.hubName?.localeCompare(b?.hubName),
    render: (text) => {
      return (
        <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray capitalize">
          {text || "--"}
        </div>
      );
    },
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray whitespace-nowrap">
        Status
      </div>
    ),
    dataIndex: "status",
    sorter: (a, b) => a.status - b.status,
    render: (text) => <div className="py-1">{getRentalStatus(+text)}</div>,
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray whitespace-nowrap">
        Requested on
      </div>
    ),
    dataIndex: "submittedAt",
    sorter: (a, b) => a?.submittedAt?.localeCompare(b?.submittedAt),
    render: (text) => (
      <div className="font-aileron text-dark-gray">
        <p className="font-semibold text-xs leading-[14.5px]">
          {dayjs(text).format("DD-MM-YYYY")}
        </p>
        <p className="font-normal text-10 leading-3 uppercase">
          {dayjs(text).format("hh:mm:ss a")}
        </p>
      </div>
    ),
  },
  {
    title: () => <div />,
    dataIndex: "id",
    render: (text, record) => (
      <div>
        <RequestDetailCTA rental={record} />
      </div>
    ),
  },
];

export const rentalStatusFilters = [
  {
    id: RENTAL_STATUS.PENDING,
    value: getRentalStatus(RENTAL_STATUS.PENDING),
  },
  {
    id: RENTAL_STATUS.ASSIGN_TRIKE,
    value: getRentalStatus(RENTAL_STATUS.ASSIGN_TRIKE),
  },
  {
    id: RENTAL_STATUS.APPROVED,
    value: getRentalStatus(RENTAL_STATUS.APPROVED),
  },
  {
    id: RENTAL_STATUS.REJECTED,
    value: getRentalStatus(RENTAL_STATUS.REJECTED),
  },
  {
    id: RENTAL_STATUS.DRIVER_CANCEL,
    value: getRentalStatus(RENTAL_STATUS.DRIVER_CANCEL),
  },
  {
    id: RENTAL_STATUS.ONGOING,
    value: getRentalStatus(RENTAL_STATUS.ONGOING),
  },
  {
    id: RENTAL_STATUS.COMPLETED,
    value: getRentalStatus(RENTAL_STATUS.COMPLETED),
  },
];
